import Landing from './components'

export default {
  key: 'landing',
  exact: true,
  path: '/:token',
  component: Landing,
}
